// removed by extract-text-webpack-plugin
module.exports = {"img":"_3HTgnYJWv95U-pWkjJX98b","text":"HzUMOuFLSjqL18EumMC7Y"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/WechatPaymentModal/WechatPaymentModal.scss
 ** module id = 1044
 ** module chunks = 0
 **/